import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import Typo from 'constants/typography'
import ResponsiveImage from 'components/images/responsive-image'
import PartialBodyBlock from '../partial-body-block'

const StepBlock = ({
  t,
  isPhone,
  stepData: { contentBlock, key, order, stepImage, title },
}) => (
  <div key={key} className="ttb-step__step-block">
    <div className="ttb-step__image-block">
      <ResponsiveImage
        className="ttb-step__step-image"
        imgRatio={!isPhone ? 1 : 1.0222}
        src={stepImage}
        alt={`ttbh_step_${order}`}
        lazy
      />
    </div>
    <div className={clsx('ttb-step__content__wrapper')}>
      <span
        className={clsx(
          'ttb-step__content-title',
          !isPhone ? Typo.h4 : Typo.h6,
        )}
      >
        {hasLocizeTranslation(t, title.disabledKey, title.value)}
      </span>
      {contentBlock.map((block) => (
        <PartialBodyBlock blockData={block} />
      ))}
    </div>
  </div>
)

StepBlock.propTypes = {
  isPhone: PropTypes.bool.isRequired,
  stepData: PropTypes.shape({
    contentBlock: PropTypes.arrayOf(PropTypes.shape({})),
    key: PropTypes.string,
    order: PropTypes.number,
    stepImage: PropTypes.string,
    title: PropTypes.shape({
      disabledKey: PropTypes.string,
      value: PropTypes.string,
    }),
  }).isRequired,
  t: PropTypes.func.isRequired,
}

const Extended = withI18next()(StepBlock)

export default connect((state) => ({
  isPhone: state.device.isPhone,
}))(Extended)
